import { connect } from 'react-redux'
import moment from 'moment'
import { getInstanceSettings } from 'app/selectors'
import { AffiliationGrid } from '../components/AffiliationGrid'
import * as affiliationSelectors from '../selectors'

export interface StateToProps {
    affiliationSettings?: AffiliationSettingsDto
    controlId: number
    data?: AffiliationDataRecord[]
}

export interface AffiliationGridStateToProps {
    affiliationSettings?: AffiliationSettingsDto
    data?: AffiliationDataRecord[]
    displayEndDateTime?: moment.Moment | string
    displayStartDateTime?: moment.Moment
    showModule: boolean
    subTitleStyle?: React.CSSProperties
    titleStyle?: React.CSSProperties
    showSubTitle: boolean
    showTitle: boolean
    labelStyle?: React.CSSProperties
    percentageStyle?: React.CSSProperties
}

export const mapStateToProps = (state: RootState): StateToProps & AffiliationGridStateToProps => {
    const affiliationSettings = getInstanceSettings(state) as AffiliationSettingsDto | undefined
    const titleStyle = affiliationSelectors.getTitleTextStyle(state) as React.CSSProperties
    const subTitleStyle = affiliationSelectors.getSubTitleTextStyle(state) as React.CSSProperties
    const showModule = imod.cms.scoreboards.overrideDisplayDate || affiliationSelectors.getShowModule(state)
    const data = state.affiliation && state.affiliation.data
    const labelStyle = affiliationSelectors.getLabelTextStyle(state) as React.CSSProperties
    const percentageStyle = affiliationSelectors.getPercentageTextStyle(state) as React.CSSProperties
    return {
        data,
        controlId: state.config.controlId,
        affiliationSettings,
        titleStyle,
        subTitleStyle,
        showModule,
        showTitle: Boolean(titleStyle && showModule),
        showSubTitle: Boolean(affiliationSettings && affiliationSettings.moduleSubTitle && subTitleStyle && showModule),
        labelStyle,
        percentageStyle,

    }
}

export const Affiliation = connect(mapStateToProps)(AffiliationGrid)
